// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__4EPq-","name":"Header_name__3wamR","birthday":"Header_birthday__1-2-G","skeleton":"Header_skeleton__1RbVe"};